<template>
  <div class="page-container checkContent-page">
    <div class="layout-library">
      <!-- 左侧：筛选条件 -->
      <div class="left-panel">
        <div class="card">
          <div class="card-header">
            <span class="card-title">筛选条件</span>
          </div>

          <div class="filter-scroll-container">
            <!-- 消防系统筛选 -->
            <div class="filter-section">
              <div class="filter-section-title">消防系统</div>
              <div class="filter-list">
                <div
                  class="filter-item"
                  :class="{ active: !queryForm.systemId }"
                  @click="handleFilterChange('systemId', '')"
                >
                  全部
                </div>
                <div
                  v-for="item in systemList"
                  :key="item.uuid"
                  class="filter-item"
                  :class="{ active: queryForm.systemId === item.uuid }"
                  @click="handleFilterChange('systemId', item.uuid)"
                >
                  {{ item.systemName }}
                </div>
              </div>
            </div>

            <!-- 设施类型筛选 -->
            <div v-show="currentDeviceTypes.length > 0" class="filter-section">
              <div class="filter-section-title">设施类型</div>
              <div class="filter-list">
                <div
                  class="filter-item"
                  :class="{ active: !queryForm.deviceTypeId }"
                  @click="handleFilterChange('deviceTypeId', '')"
                >
                  全部
                </div>
                <div
                  v-for="item in currentDeviceTypes"
                  :key="item.uuid"
                  class="filter-item"
                  :class="{ active: queryForm.deviceTypeId === item.uuid }"
                  @click="handleFilterChange('deviceTypeId', item.uuid)"
                >
                  {{ item.typeName }}
                </div>
              </div>
            </div>

            <!-- 内容类型筛选 -->
            <div class="filter-section">
              <div class="filter-section-title">内容类型</div>
              <div class="filter-list">
                <div
                  class="filter-item"
                  :class="{ active: !queryForm.contentType }"
                  @click="handleFilterChange('contentType', '')"
                >
                  全部
                </div>
                <div
                  v-for="opt in contentTypeFilterOptions"
                  :key="opt.value"
                  class="filter-item"
                  :class="{ active: queryForm.contentType === opt.value }"
                  @click="handleFilterChange('contentType', opt.value)"
                >
                  {{ opt.label }}
                </div>
              </div>
            </div>

            <!-- 适用周期筛选 -->
            <div class="filter-section">
              <div class="filter-section-title">适用周期</div>
              <div class="filter-list">
                <div
                  class="filter-item"
                  :class="{ active: !queryForm.applyCycle }"
                  @click="handleFilterChange('applyCycle', '')"
                >
                  全部
                </div>
                <div
                  v-for="opt in cycleTypeOptions"
                  :key="opt.value"
                  class="filter-item"
                  :class="{ active: queryForm.applyCycle === opt.value }"
                  @click="handleFilterChange('applyCycle', opt.value)"
                >
                  {{ opt.label }}
                </div>
              </div>
            </div>

            <!-- 状态筛选 -->
            <div class="filter-section">
              <div class="filter-section-title">启用状态</div>
              <div class="filter-list">
                <div
                  class="filter-item"
                  :class="{ active: queryForm.status === '' }"
                  @click="handleFilterChange('status', '')"
                >
                  全部
                </div>
                <div
                  class="filter-item"
                  :class="{ active: queryForm.status === 1 }"
                  @click="handleFilterChange('status', 1)"
                >
                  已启用
                </div>
                <div
                  class="filter-item"
                  :class="{ active: queryForm.status === 0 }"
                  @click="handleFilterChange('status', 0)"
                >
                  已禁用
                </div>
              </div>
            </div>
          </div>

          <!-- 匹配说明 -->
          <div class="match-info">
            <strong>匹配逻辑：</strong>任务创建时，系统根据 [消防系统] + [设施类型] + [内容类型] + [周期] 自动匹配检查内容
          </div>
        </div>
      </div>

      <!-- 右侧：内容列表 -->
      <div class="right-panel">
        <div class="card">
          <div class="card-header">
            <span class="card-title">任务内容库</span>
            <div class="btn-group">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">
                新增内容项
              </el-button>
              <el-button type="success" size="small" icon="el-icon-upload2" @click="handleImport">
                Excel导入
              </el-button>
              <el-button size="small" icon="el-icon-download" :loading="exportLoading" @click="handleExport">
                导出
              </el-button>
            </div>
          </div>

          <!-- 统计信息 -->
          <div class="library-stats">
            <div class="library-stat-item">
              <div class="library-stat-value">{{ stats.total }}</div>
              <div class="library-stat-label">内容项总数
              </div>
            </div>
            <div
              v-for="item in stats.systems"
              :key="item.systemCode"
              class="library-stat-item"
            >
              <div class="library-stat-value">{{ item.count }}</div>
              <div class="library-stat-label">{{ item.systemName }}</div>
            </div>
          </div>

          <!-- 搜索栏 -->
          <div class="search-bar">
            <el-input
              v-model="queryForm.keyword"
              placeholder="搜索内容名称/标准要求..."
              clearable
              style="width: 300px"
              @keyup.enter.native="handleQuery"
            >
              <el-button slot="append" icon="el-icon-search" @click="handleQuery"/>
            </el-input>
            <el-button type="text" style="margin-left: 10px" @click="handleReset">重置筛选</el-button>
          </div>

          <!-- 卡片列表 -->
          <div v-loading="loading" class="content-list">
            <div v-if="groupedData.length === 0" class="empty-data">
              <i class="el-icon-receiving" />
              <p>暂无数据</p>
            </div>
            <div
              v-for="group in groupedData"
              v-else
              :key="group.key"
              class="library-card"
            >
              <div class="library-card-header">
                <div class="library-card-title">
                  {{ group.deviceTypeName }} - {{ group.contentTypeName || group.contentType }} - {{ group.applyCycleName || group.applyCycle }}
                </div>
                <div class="header-actions">
                  <el-button
                    type="text"
                    size="medium"
                    icon="el-icon-plus"
                    class="add-btn"
                    title="添加检查项"
                    @click="handleAddToGroup(group)"
                  />
                  <el-button
                    type="text"
                    size="medium"
                    icon="el-icon-delete"
                    class="delete-btn"
                    title="删除组"
                    @click="handleDeleteGroup(group)"
                  />
                </div>
              </div>
              <div class="library-card-tags">
                <span class="library-tag type">{{ group.contentTypeName || group.contentType }}</span>
                <span class="library-tag cycle">{{ group.applyCycleName || group.applyCycle }}</span>
                <span class="library-tag system">{{ group.systemName }}</span>
                <span class="library-tag device">{{ group.deviceTypeName }}</span>
                <span class="library-tag count">共{{ group.items.length }}项</span>
              </div>
              <div class="library-card-content">
                <!-- 第一条内容（始终显示） -->
                <div v-if="group.items.length > 0" class="content-item">
                  <div class="item-content-wrapper">
                    <span class="item-number">1.</span>
                    <div class="item-main">
                      <p class="content-text">
                        {{ group.items[0].content }}
                      </p>
                      <p v-if="group.items[0].checkObjectName" class="content-object">
                        检查对象：{{ group.items[0].checkObjectName }}
                      </p>
                      <p v-if="group.items[0].remark" class="content-remark">
                        备注：{{ group.items[0].remark }}
                      </p>
                    </div>
                    <div class="item-status">
                      <el-tag v-if="group.items[0].allowExtraInput === 1" size="mini" type="warning" effect="plain">可填额外内容</el-tag>
                      <el-tag
                        size="mini"
                        :type="group.items[0].status === 1 ? 'success' : 'info'"
                        effect="plain"
                      >
                        {{ group.items[0].status === 1 ? '启用' : '禁用' }}
                      </el-tag>
                    </div>
                    <div class="item-actions">
                      <el-button type="text" size="mini" icon="el-icon-edit" class="edit-btn" @click="handleEdit(group.items[0])"/>
                      <el-button type="text" size="mini" icon="el-icon-delete" class="delete-btn" @click="handleDelete(group.items[0])"/>
                    </div>
                  </div>
                </div>

                <!-- 剩余内容（展开显示） -->
                <div v-show="group.expanded">
                  <div
                    v-for="(item, index) in group.items.slice(1)"
                    :key="item.uuid"
                    class="content-item"
                  >
                    <div class="item-content-wrapper">
                      <span class="item-number">{{ index + 2 }}.</span>
                      <div class="item-main">
                        <p class="content-text">
                          {{ item.content }}
                        </p>
                        <p v-if="item.checkObjectName" class="content-object">
                          检查对象：{{ item.checkObjectName }}
                        </p>
                        <p v-if="item.remark" class="content-remark">
                          备注：{{ item.remark }}
                        </p>
                      </div>
                      <div class="item-status">
                        <el-tag v-if="item.allowExtraInput === 1" size="mini" type="warning" effect="plain">可填额外内容</el-tag>
                        <el-tag
                          size="mini"
                          :type="item.status === 1 ? 'success' : 'info'"
                          effect="plain"
                        >
                          {{ item.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                      </div>
                      <div class="item-actions">
                        <el-button type="text" size="mini" icon="el-icon-edit" class="edit-btn" @click="handleEdit(item)"/>
                        <el-button type="text" size="mini" icon="el-icon-delete" class="delete-btn" @click="handleDelete(item)"/>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 展开/收起按钮 -->
                <div
                  v-if="group.items.length > 1"
                  class="expand-toggle"
                  @click="toggleExpand(group)"
                >
                  <span v-if="!group.expanded">查看剩余 {{ group.items.length - 1 }} 项 <i class="el-icon-arrow-down" /></span>
                  <span v-else>收起 <i class="el-icon-arrow-up" /></span>
                </div>
              </div>
              <div class="library-card-footer">
                <div class="library-card-meta">
                  <span>最后更新时间：{{ formatDateTime(group.items[0].updateTime) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <CheckContentDialog
      :visible.sync="dialogVisible"
      :type="dialogType"
      :data="currentData"
      :system-list="systemList"
      :device-type-list="typeList"
      :default-system-id="queryForm.systemId"
      :default-device-type-id="queryForm.deviceTypeId"
      @success="handleDialogSuccess"
    />

    <!-- 导入弹窗 -->
    <ImportCheckContentDialog
      :visible.sync="importVisible"
      @success="handleImportSuccess"
    />
  </div>
</template>

<script>
// 服务
import { checkContentService } from './checkContent.service';
import { deviceTypeService } from '@/features/gnmk/deviceType/deviceType.service';
// 工具函数
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil.js';
import { formatDateTime } from '@/features/common/utils/dateTimeUtil.js';
import {
  CYCLE_TYPE_OPTIONS,
  TASK_TYPE_OPTIONS
} from '@/features/gnmk/constants/taskCycleEnums';
// 组件
import CheckContentDialog from './checkContentDialog';
import ImportCheckContentDialog from './importCheckContentDialog';

export default {
  name: 'JcnrkList',
  components: {
    CheckContentDialog,
    ImportCheckContentDialog
  },
  data () {
    return {
      systemList: [],
      typeList: [],
      queryForm: {
        keyword: '',
        systemId: '',
        deviceTypeId: '',
        contentType: '',
        applyCycle: '',
        status: ''
      },
      stats: {
        total: 0,
        systems: []
      },
      tableData: [],
      groupedData: [], // 分组后的数据
      loading: false,
      // 弹窗相关
      dialogVisible: false,
      dialogType: 'add',
      currentData: {},

      // 导入导出相关
      importVisible: false,
      exportLoading: false,

      cycleTypeOptions: CYCLE_TYPE_OPTIONS
    };
  },
  computed: {
    currentDeviceTypes () {
      if (!this.queryForm.systemId) return [];
      return this.typeList.filter(t => t.systemId === this.queryForm.systemId);
    },
    contentTypeFilterOptions () {
      return TASK_TYPE_OPTIONS.map(o => ({ value: o.value, label: `${o.label}项` }));
    }
  },
  methods: {
    initData () {
      this.loadBaseData();
      this.loadStats();
      this.loadData();
    },

    loadBaseData () {
      deviceTypeService.listFireSystems().then(res => this.systemList = res.data || []);
      deviceTypeService.listDeviceTypes().then(res => this.typeList = res.data || []);
    },

    loadStats () {
      checkContentService.getCheckContentStats().then(res => {
        const list = res.data || [];
        let total = 0;
        list.forEach(item => total += item.count);
        this.stats = {
          total: total,
          systems: list
        };
      });
    },

    loadData () {
      this.loading = true;
      const params = {
        ...this.queryForm
      };
      checkContentService.listCheckContents(params)
        .then(res => {
          this.tableData = res.data || [];
          this.groupDataByType();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 按类型分组数据
    groupDataByType () {
      const groups = {};
      this.tableData.forEach(item => {
        const key = `${item.systemId}_${item.deviceTypeId}_${item.contentType}_${item.applyCycle}`;
        if (!groups[key]) {
          groups[key] = {
            key: key,
            systemId: item.systemId,
            systemName: item.systemName,
            deviceTypeId: item.deviceTypeId,
            deviceTypeName: item.deviceTypeName,
            contentType: item.contentType,
            contentTypeName: item.contentTypeName,
            applyCycle: item.applyCycle,
            applyCycleName: item.applyCycleName,
            status: item.status,
            expanded: false, // 默认收起
            items: []
          };
        }
        groups[key].items.push(item);
      });
      // 对每个组内的 items 进行排序（可选，按 updateTime 或其他字段）
      Object.values(groups).forEach(group => {
        group.items.sort((a, b) => (new Date(b.updateTime) - new Date(a.updateTime)));
      });
      this.groupedData = Object.values(groups);
    },

    handleFilterChange (key, value) {
      this.queryForm[key] = value;
      // 联动重置
      if (key === 'systemId') {
        this.queryForm.deviceTypeId = '';
      }
      this.handleQuery();
    },

    handleQuery () {
      this.loadData();
    },

    handleReset () {
      this.queryForm = {
        keyword: '',
        systemId: '',
        deviceTypeId: '',
        contentType: '',
        applyCycle: '',
        status: ''
      };
      this.handleQuery();
    },

    handleAdd () {
      this.dialogType = 'add';
      this.currentData = {};
      this.dialogVisible = true;
    },

    handleAddToGroup (group) {
      this.dialogType = 'add';
      this.currentData = {
        systemId: group.systemId,
        deviceTypeId: group.deviceTypeId,
        contentType: group.contentType,
        applyCycle: group.applyCycle
      };
      this.dialogVisible = true;
    },

    toggleExpand (group) {
      this.$set(group, 'expanded', !group.expanded);
    },

    handleEdit (row) {
      this.dialogType = 'edit';
      this.currentData = row;
      this.dialogVisible = true;
    },

    handleDelete (row) {
      this.$confirm('确认删除该检查项吗？', '提示', { type: 'warning' }).then(() => {
        this.loading = true;
        checkContentService.deleteCheckContent(row.uuid).then(() => {
          this.$message.success('删除成功');
          this.loadData();
          this.loadStats();
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },

    handleDeleteGroup (group) {
      this.$confirm(`确认删除该组的所有${group.items.length}个检查项吗？`, '提示', { type: 'warning' }).then(() => {
        this.loading = true;
        const uuids = group.items.map(item => item.uuid);
        checkContentService.batchDeleteCheckContent(uuids).then(() => {
          this.$message.success('删除成功');
          this.loadData();
          this.loadStats();
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },

    handleDialogSuccess () {
      this.loadData();
      this.loadStats();
    },

    handleImport () {
      this.importVisible = true;
    },

    handleImportSuccess () {
      this.$message.success('导入完成');
      this.loadData();
      this.loadStats();
    },

    handleExport () {
      this.exportLoading = true;
      const params = {
        ...this.queryForm
      };
      checkContentService.exportCheckContent(params).then(res => {
        downloadFromApiBlobResponse(res, '检查内容库列表.xlsx');
        this.$message.success('导出成功');
      }).finally(() => {
        this.exportLoading = false;
      });
    },

    formatDateTime
  },
  mounted () {
    this.initData();
  }
};
</script>

<style scoped lang="scss">
.checkContent-page {
  padding: 15px;
  background: #f5f7fa;
  min-height: calc(100vh - 84px);

  .layout-library {
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 15px;

    .right-panel {
      min-width: 0; /* 关键：防止 Grid 列被撑开 */
    }
  }

  .card {
    background: #fff;
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    max-height: 750px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #ebeef5;
      flex-shrink: 0; /* 防止头部被压缩 */

      .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  /* 筛选区域 */
  .filter-scroll-container {
    flex: 1;
    overflow-y: auto;
    margin-right: -5px;
    padding-right: 5px;
    max-height: 750px;
    /* 移除 max-height，让其自适应父容器高度 */
  }

  .filter-section { margin-bottom: 18px; }

  .filter-section-title {
    font-size: 13px;
    color: #909399;
    margin-bottom: 10px;
    padding-left: 10px;
    border-left: 3px solid #2296f7;
  }

  .filter-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .filter-item {
    padding: 5px 12px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
    color: #606266;

    &:hover {
      border-color: #2296f7;
      color: #2296f7;
    }

    &.active {
      background: #ecf5ff;
      border-color: #2296f7;
      color: #2296f7;
    }
  }

  .match-info {
    margin-top: 15px;
    padding: 12px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    font-size: 12px;
    color: #409eff;
    line-height: 1.5;
    flex-shrink: 0;
  }

  /* 统计信息 */
  .library-stats {
    display: flex;
    gap: 20px;
    padding: 10px 15px;
    background: #f5f7fa;
    border-radius: 6px;
    margin-bottom: 10px;
    flex-shrink: 0; /* 防止被压缩 */
    overflow-x: auto; /* 允许横向滚动 */

    /* 优化滚动条样式 */
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e4e7ed;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    .library-stat-item {
      text-align: center;
      min-width: 80px;
      flex-shrink: 0; /* 防止统计项被压缩 */

      .library-stat-value {
        font-size: 24px;
        font-weight: 600;
        color: #409EFF;
        margin-bottom: 4px;
      }

      .library-stat-label {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  /* 搜索栏 */
  .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-shrink: 0; /* 防止被压缩 */
  }

  /* 内容列表 */
  .content-list {
    flex: 1;
    overflow-y: auto;
    padding-right: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-content: flex-start; /* 卡片从顶部开始排列 */
  }

  .empty-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #909399;
    min-height: 400px; /* 确保有足够的高度居中 */

    i {
      font-size: 60px;
      margin-bottom: 15px;
      color: #e4e7ed;
    }

    p {
      font-size: 14px;
      margin: 0;
    }
  }

  /* 卡片样式 */
  .library-card {
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 8px 10px; /* 减小内边距 15px -> 12px */
    transition: all 0.2s ease;
    width: calc(50% - 5px); /* 两列布局，减去gap的一半 */
    box-sizing: border-box;

    &:hover {
      border-color: #2296f7;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    }

    .library-card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 0px; /* 减小间距 12px -> 8px */

      .library-card-title {
        font-size: 15px;
        font-weight: 550;
        color: #303133;
        flex: 1;
        margin-right: 10px;
        line-height: 1.4;
      }

      .header-actions {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }

      .edit-btn {
        color: #409eff;
        padding: 0;
        margin-right: 8px;
        &:hover { color: #66b1ff; }
      }

      .delete-btn {
        color: #fc5757;
        padding: 0;
        &:hover { color: #fc5757; }
      }
    }

    .library-card-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-bottom: 8px; /* 减小间距 12px -> 8px */

      .library-tag {
        padding: 3px 6px; /* 减小标签内边距 */
        border-radius: 4px;
        font-size: 11px;

        /* 修改颜色策略：type改为紫色，system/device改为蓝色 */
        &.type { background: #f4ecfb; color: #a27ce3; }
        &.system { background: #e8f4ff; color: #409eff; }
        &.device { background: #ecf5ff; color: #2296f7; }
        &.cycle { background: #fdf6ec; color: #e6a23c; }
        &.count { background: #f0f9ff; color: #67c23a; font-weight: 600; }
      }
    }

    .library-card-content {
      font-size: 12px;
      color: #606266;
      line-height: 1.5;
      margin-bottom: 8px;

      .content-item {
        padding: 8px 10px;
        background: #f9fafb;
        border-radius: 4px;
        margin-bottom: 6px;
        border-left: 3px solid #2296f7;
        transition: all 0.2s;

        &:hover {
          background: #f0f7ff;
        }

        .item-content-wrapper {
          display: flex;
          align-items: flex-start;
          gap: 8px;

          .item-number {
            flex-shrink: 0;
            font-weight: 600;
            color: #2296f7;
            line-height: 1.6;
            width: 20px; /* 固定宽度对齐 */
          }

          .item-main {
            flex: 1;
            min-width: 0; /* 防止flex子项溢出 */

            .content-text {
              margin: 0;
              color: #303133;
              line-height: 1.6;
              white-space: pre-wrap; /* 保留换行符 */
              word-break: break-all;
              text-align: justify;
            }

            .content-object {
              margin: 4px 0 0;
              color: #409eff;
              font-size: 12px;
            }

            .content-remark {
              margin: 4px 0 0 0;
              color: #909399;
              font-size: 12px;
              background: #fff;
              padding: 2px 6px;
              border-radius: 2px;
              display: inline-block;
            }
          }

          .item-actions {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-left: 4px;
            opacity: 0.6; /* 默认半透明 */
            transition: opacity 0.2s;

            .el-button {
              padding: 4px;
              margin-left: 4px;

              &.edit-btn {
                color: #409eff;
                &:hover { color: #66b1ff; }
              }

              &.delete-btn {
                color: #f56c6c;
                &:hover { color: #f78989; }
              }
            }
          }
        }

        &:hover .item-actions {
          opacity: 1;
        }
      }

      .expand-toggle {
        text-align: center;
        padding: 8px 0 0;
        color: #909399;
        cursor: pointer;
        font-size: 12px;
        border-top: 1px dashed #ebeef5;
        margin-top: 5px;
        transition: all 0.2s;

        &:hover {
          color: #409eff;
        }

        i { margin-left: 4px; }
      }
    }

    .library-card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 5px; /* 减小间距 10px -> 8px */
      border-top: 1px dashed #ebeef5; /* 改为虚线更轻量 */

      .library-card-meta {
        font-size: 12px;
        color: #c0c4cc; /* 颜色更淡一点 */
      }
    }
  }

  .pagination {
    margin-top: 15px;
    text-align: right;
    flex-shrink: 0; /* 防止被压缩 */
  }

  /* 详情弹窗样式 */
  .detail-dialog-content {
    .detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 2px solid #ebeef5;

      .detail-tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }

      .detail-count {
        font-size: 14px;
        color: #909399;
        font-weight: 600;
      }
    }

    .detail-list {
      max-height: 500px;
      overflow-y: auto;
      padding-right: 10px;

      .detail-item {
        padding: 15px;
        background: #f9fafb;
        border-radius: 6px;
        margin-bottom: 12px;
        border-left: 4px solid #409eff;
        transition: all 0.2s ease;

        &:hover {
          background: #ecf5ff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }

        &:last-child {
          margin-bottom: 0;
        }

        .detail-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .detail-item-number {
            font-size: 16px;
            font-weight: 700;
            color: #409eff;
          }

          .detail-item-actions {
            .el-button {
              padding: 5px 10px;
            }
          }
        }

        .detail-item-content {
          .detail-content-text {
            margin: 0;
            color: #303133;
            font-size: 14px;
            line-height: 1.8;
            word-break: break-all;
          }

          .detail-content-remark {
            margin: 10px 0 0 0;
            padding: 8px 12px;
            background: #fff;
            border-radius: 4px;
            color: #606266;
            font-size: 12px;
            border-left: 3px solid #e6a23c;

            strong {
              color: #e6a23c;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
